export default __webpack_public_path__ + "e3368ca.png";